import { useEffect } from 'react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom'

import * as Sentry from '@sentry/react'

import { isTestEnvironment } from './environment.ts'

let initialized = false

const META_IN_APP_BROWSER_BRIDGE_ERROR_FRAGMENTS = ['window._META', 'IABInnerFrame']

const filterLowRelevanceEvents = (event: Sentry.ErrorEvent, _hint: Sentry.EventHint): Sentry.ErrorEvent | null => {
    const message = event.message || event.exception?.values?.[0]?.value || ''
    const tags = event.tags || {}

    console.log('Filtering low relevance events', { message, tags })

    if (META_IN_APP_BROWSER_BRIDGE_ERROR_FRAGMENTS.some(fragment => message.includes(fragment))) {
        return null
    }

    if (
        tags['browser.name'] === 'Instagram' &&
        (message?.includes('Java object is gone') ||
            message?.includes('Error invoking postMessage: Java exception was raised during method invocation'))
    ) {
        return null
    }

    return event
}

export function initSentry(): void {
    if (initialized || typeof window === 'undefined') return
    initialized = true

    Sentry.init({
        environment: isTestEnvironment ? 'test' : 'production',
        dsn: 'https://066db57e875787122ebf1855ab277ba3@o4509276495020032.ingest.de.sentry.io/4509276496396368',
        ignoreErrors: [
            'Java object is gone',
            'Error invoking postMessage: Java exception was raised during method invocation',
            'window.webkit.messageHandlers',
            ...META_IN_APP_BROWSER_BRIDGE_ERROR_FRAGMENTS,
            'TrackerStorageType is not defined',
            "Can't find variable: EmptyRanges",
            'Database deleted by request of the user',
            'swbrowser is not defined',
            'xbrowser is not defined',
        ],
        debug: isTestEnvironment,
        integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
            Sentry.replayIntegration({
                networkDetailAllowUrls: ['*'],
            }),
            Sentry.browserProfilingIntegration(),
        ],

        beforeSend: filterLowRelevanceEvents,

        tracesSampleRate: 1.0,
        profilesSampleRate: 1.0,

        tracePropagationTargets: [
            'localhost',
            'https://europe-southwest1-tipi-ink.cloudfunctions.net/deleteIngredient',
            'https://europe-west1-tipi-ink.cloudfunctions.net/notionRateLimitHandler',
            /^https:\/\/us-central1-tipi-ink\.cloudfunctions\.net/,
        ],

        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
    })
}

export { Sentry }
